import Link from '@decisiv/ui-components/lib/components/Link';

import type { ManagedDepotsType } from '../..';

interface CellProps {
  rowData: ManagedDepotsType;
}

export default function NameCell({ rowData: { id } }: CellProps) {
  return <Link to={`/management/depot/${id}`} text={id} />;
}
